import { Box, BoxProps, Tabs as MUITabs, styled, Tab, TabsProps } from '@mui/material';
import { ReactNode } from 'react';

const FilledTab = styled(Tab)`
    min-height: 31px;
    height: 31px;
    border-radius: 5px 0 0 0;
    background-color: #EDEDED;
    color: black;

    &.Mui-selected {
        background-color: white;
    },
`;

const CustomTab = styled(Tab)`
    font-family: Inter;
    color: black;
    font-weight: 500;
    font-size: 14px;

    &.Mui-selected {
        color: black;
    }
`;

export type CustomTabsProps = TabsProps & { boxProps?: BoxProps; endElement?: ReactNode; underline?: boolean };

const CustomTabs = ({ boxProps, endElement, underline = true, ...props }: CustomTabsProps) => (
    <Box
        {...boxProps}
        sx={{
            ...boxProps?.sx,
            borderBottom: underline ? 1 : 0,
            borderColor: 'divider',
            ...(endElement ? { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } : {}),
        }}
    >
        <MUITabs
            {...props}
            slotProps={{
                indicator: {
                    sx: {
                        display: 'block',
                    },
                },
            }}
        />
        {endElement ? endElement : null}
    </Box>
);

const Tabs = Object.assign(CustomTabs, {
    Filled: FilledTab,
    Tab: CustomTab,
});

export { Tabs };
